import React, { Component,} from 'react';
import { connect } from 'react-redux';
import { Card, Form } from 'react-bootstrap';
import Style from './AdvancedSettings.module.css';
import { getScanConfigSettings, updateScanConfigSettings, unSetStatusCode } from '../store/entities/customers';
import { getLookupData, getScanRuleLookupData, getMMScanPolicyLookupData, getMMImageSizeLookupData } from '../store/entities/lookup'

import LoaderWrapper from "./common/LoaderWrapper/LoaderWrapper";
import ConfirmPopup from "./common/popover/confirmPopup";

const DEFAULT_SCAN_CONFIG_SETTINGS = {
  mmEnabled: false,
  lookupCode: 'PP1',
  demomodeEnabled: false,
  ppEnabled: true,
  ssOptEnabled: false,
  srEnabled: false,
  srCode: "RULE_DEFAULT",
  strMMPolicy: "BBP1",
  imageSize:"MM_IMG_SIZE_02",
  cme:false
}

class ScanSettings extends Component {

  constructor(props) {
    super(props)
    this.state = {
      scanConfigSettings: DEFAULT_SCAN_CONFIG_SETTINGS,
      showConfirmationPopup: false
    };
    this.originalScanConfigSettings = {};
  }

 async componentDidMount() {
      this.props.getLookupData();
      this.props.getScanRuleLookupData();
      this.props.getMMScanPolicyLookupData();
      this.props.getMMImageSizeLookupData();
      if (this.props.selectedCustomer?.id) {
        this.props.getScanConfigSettings(this.props.selectedCustomer?.id);
        this.originalScanConfigSettings = this.props.scanConfigSettings;
      }

    }

  async componentDidUpdate(prevProps) {
    if(this.props.scanConfigSettings && prevProps.scanConfigSettings !== this.props.scanConfigSettings) {
      let scanConfigSettings = this.props.scanConfigSettings
      if(scanConfigSettings){
        this.setState({scanConfigSettings})
        this.originalScanConfigSettings = this.props.scanConfigSettings;
      }
      else{
        console.warn("Scan settings not found! Setting default settings")
        this.setState({scanConfigSettings: DEFAULT_SCAN_CONFIG_SETTINGS});
        this.originalScanConfigSettings = DEFAULT_SCAN_CONFIG_SETTINGS;

      }
    }
    if(prevProps.selectedCustomer !== this.props.selectedCustomer){
      this.props.getScanConfigSettings(this.props.selectedCustomer?.id);
      this.originalScanConfigSettings = this.props.scanConfigSettings;
    }
    
  }

  handleOnmmEnabledChange = (e) => {
    let checked = e.target.checked;
    if(checked){
      this.setState(prevState => ({
        scanConfigSettings: {
          ...prevState.scanConfigSettings,
          lookupCode: this.props.lookupData.filter(model => model.code === 'OPENAI1')[0].code
        }
      }))
    }
    else{
      this.setState(prevState => ({
        scanConfigSettings: {
          ...prevState.scanConfigSettings,
          lookupCode: this.props.lookupData.filter(model => model.code === 'PP1')[0].code
        }
      }))
    }
    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        mmEnabled: checked
      }
    }))
  }

  handlelookupCodeChange = (e) => {
    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        lookupCode: e.target.value
      }
    }))
  }

  handleScanRulelookupCodeChange = (e) => {
    let selectedCode = e.target.value;
    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        srCode: selectedCode
      }
    }))
  }

  handleMMScanPolicyCodeChange = (e) => {
    let selectedCode = e.target.value;
    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        strMMPolicy : selectedCode
      }
    }))
  }

  handleMMImageSizeChange = (e) => {
    let selectedCode = e.target.value;
    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        imageSize : selectedCode
      }
    }))
  }

  handleOnDemoModeEnabledChange = (e) => {
    let checked = e.target.checked;
    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        demomodeEnabled: checked,
        ssOptEnabled: checked ? prevState.scanConfigSettings.ssOptEnabled : false,
        srEnabled: checked ? false : prevState.scanConfigSettings.srEnabled,
      }
    }))
  }
  
  handleOnPPEnabledChange = (e) => {
    let checked = e.target.checked;

    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        ppEnabled: checked
      }
    }))
  }

  handleOnSSOptEnabledChange = (e) => {
    if(this.state.scanConfigSettings.demomodeEnabled){
      let checked = e.target.checked;
        this.setState(prevState => ({
          scanConfigSettings: {
            ...prevState.scanConfigSettings,
            ssOptEnabled: checked
          }
        }))
    }

    else {
      console.log("Demo mode is not enabled")
    }
  }

  handleOnScanRuleEnabledChange = (e) => {
    let checked = e.target.checked;
    // if(checked){
    //   this.setState(prevState => ({
    //     scanConfigSettings: {
    //       ...prevState.scanConfigSettings,
    //       srCode: this.props.lookupData.filter(scanRuleConfig => scanRuleConfig.code === 'RULE_ADVANCE_PII')[0].code
    //     }
    //   }))
    // }
    // else{
    //   this.setState(prevState => ({
    //     scanConfigSettings: {
    //       ...prevState.scanConfigSettings,
    //       srCode: this.props.lookupData.filter(scanRuleConfig => scanRuleConfig.code === 'RULE_DEFAULT')[0].code
    //     }
    //   }))
    // }
    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        srEnabled: checked,
        demomodeEnabled: checked ? false : prevState.scanConfigSettings.demomodeEnabled,
        ssOptEnabled: checked ? false : prevState.scanConfigSettings.ssOptEnabled,
      }
    }))
  }

  handleOnCredMonEnabledChange = (e) => {
    let checked = e.target.checked;

    this.setState(prevState => ({
      scanConfigSettings: {
        ...prevState.scanConfigSettings,
        cme: checked
      }
    }))
  }

  handleOnUpdate = () =>{
    this.setState({
      showConfirmationPopup: true
    })
  }

  handleOnCancel = () => {
    this.setState({
      scanConfigSettings: this.originalScanConfigSettings
    })
  }

  handleOnClose = () => { 
    this.setState({
      scanConfigSettings: this.originalScanConfigSettings,
      showConfirmationPopup: false
    })
    this.props.unSetStatusCode();

  }

  updateScanConfSettings = () => {
    if (this.validateScanConfigSettings(this.state.scanConfigSettings)){
      let requestBody = {
        mmEnabled: this.state.scanConfigSettings.mmEnabled,
        lookupCode: this.state.scanConfigSettings.lookupCode,
        demomodeEnabled: this.state.scanConfigSettings.demomodeEnabled,
        ssOptEnabled: this.state.scanConfigSettings.ssOptEnabled,
        ppEnabled: this.state.scanConfigSettings.ppEnabled,
        srEnabled: this.state.scanConfigSettings.srEnabled,
        srCode: this.state.scanConfigSettings.srCode,
        strMMPolicy: this.state.scanConfigSettings.strMMPolicy,
        imageSize: this.state.scanConfigSettings.imageSize,
        cme: this.state.scanConfigSettings.cme
      }
      // console.log("Res:", requestBody)
      this.props.updateScanConfigSettings(this.props.selectedCustomer?.id, requestBody);
    }
    else console.warn("Scan Config Settings are not valid!")

    this.setState({
      showConfirmationPopup: false
    })

    this.originalScanConfigSettings = this.state.scanConfigSettings;
  }

  validateScanConfigSettings = (scanConfigSettings) => {
    let errors = [];

    if(scanConfigSettings.ssOptEnabled && !scanConfigSettings.demomodeEnabled){
      errors.push("Screenshot Optimisation can only be enabled when Demo Mode is ON")
    }

    if(errors.length > 0){
      console.error("Errors in Scan Config Settings: ", errors)
      return false;
    }
    return true;

  }

  render() {
    return (
      <div className={`mt-3`}>
        <>
          <div className={`${Style.profileFontStyle}`}>
                Scan Settings
              </div>
          <Card className={`${Style.parentCardContainer}`}>
            {
            this.props.settingsLoading ?
            <LoaderWrapper loading={this.props.settingsLoading} waitForData={false} isFlex={true} styles={{top: '100px'}}></LoaderWrapper>
          :
              <Card.Body className={`${Style.parentCardBodyContainer}`}>
                <Card className={`${Style.childCardContainer}`}>
                  <Card.Body>
                  <Form>
                    <Form.Group className={`mb-3 ${Style.setting}`} controlId="formBasicEmail">
                    <Form.Label style={{ fontSize: '20px' }}><h4>Scanning Rule</h4>
                    <Form.Text muted style={{ fontSize: '13.5px' }}>If disabled default value will be Scan Password DOM </Form.Text>
                    </Form.Label>
                      <Form.Check
                        type="switch"
                        id="scanRule-switch"
                        label=""
                        checked={!!this.state.scanConfigSettings.srEnabled}
                        onChange={(e) => this.handleOnScanRuleEnabledChange(e)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control as="select" name="scanRulelookupCode" onChange={(e) => this.handleScanRulelookupCodeChange(e)} value={this.state.scanConfigSettings.srCode} disabled={!this.state.scanConfigSettings.srEnabled}>
                            {
                                this.props.lookupData.map((scanRuleConfig) => (
                                    scanRuleConfig.lookupId === "LKP_SCANNING_RULE" &&
                                    <option key={scanRuleConfig.code} value={scanRuleConfig.code}>{scanRuleConfig.value}</option>
                                ))
                            }
                        </Form.Control>
                    </Form.Group>
                  </Form>
                  <Form>
                    <Form.Group className={`mb-1 ${Style.setting}`} controlId="formBasicEmail">
                    <Form.Label style={{ fontSize: '20px' }}> <h4>Demo Mode</h4></Form.Label>
                        
                      <Form.Check
                        type="switch"
                        id="demo-switch"
                        label=""
                        checked={!!this.state.scanConfigSettings.demomodeEnabled} //!! is to convert the value to boolean
                        onChange={(e) => this.handleOnDemoModeEnabledChange(e)}
                      />
                    </Form.Group>
                  </Form>

                  <Form className="mb-3">
                    <Form.Group className={`mb-1 ${Style.setting}`} controlId="formBasicEmail">
                    <Form.Label className={`${Style.textStyle}`} style={{ fontSize: '20px', paddingLeft:'20px' }}>Screenshot Optimisation
                    <Form.Text muted style={{ fontSize: '13.5px' }}>When turned ON, Screenshot processing will be optimised. This option is only available if Demo Mode is ON </Form.Text>
                    </Form.Label> 
                      <Form.Check
                        type="switch"
                        id="ss-opt-switch"
                        label=""
                        checked={!!this.state.scanConfigSettings.ssOptEnabled} //!! is to convert the value to boolean
                        disabled={!this.state.scanConfigSettings.demomodeEnabled}
                        onChange={(e) => this.handleOnSSOptEnabledChange(e)}
                      />   
                    </Form.Group>
                     <Card.Text className={`${Style.textStyle}`} style={{ fontSize: '13.5px' }}>
                        *Either Demo Mode or Scanning rule can be enabled at a time 
                        <br/>
                        *PII - Personal Identifiable Information     
                        <br/>
                      </Card.Text>
                  </Form>  

                  <Form>
                    <Form.Group className={`mb-3 ${Style.setting}`} controlId="formBasicEmail">
                    <Form.Label style={{ fontSize: '20px' }}> <h4>Credential Monitoring</h4>
                    <Form.Text muted style={{ fontSize: '13.5px' }}>When turned ON, Credential Monitoring will be enabled. Users will be alerted if they use compromised credentials.</Form.Text>
                    </Form.Label> 
                      <Form.Check
                        type="switch"
                        id="cred-mon-switch"
                        label=""
                        checked={!!this.state.scanConfigSettings.cme} //!! is to convert the value to boolean
                        onChange={(e) => this.handleOnCredMonEnabledChange(e)}
                      />     
                    </Form.Group>
                  </Form>
                </Card.Body>
              </Card>
              <Card className={`${Style.childCardContainer}`}>
                <Card.Body>
                  <Card.Title className={`${Style.textStyle}`} style={{ fontSize: '20px' }}>
                    <h4>AI Models</h4>
                  </Card.Title>
                  <Form>
                    <Form.Group className={`mb-3 ${Style.setting}`} controlId="formBasicEmail">
                    <Form.Label className={`${Style.textStyle}`} style={{ fontSize: '20px' }}>Process Page</Form.Label> 
                      <Form.Check
                        type="switch"
                        id="pp-switch"
                        label=""
                        checked={!!this.state.scanConfigSettings.ppEnabled}
                        onChange={(e) => this.handleOnPPEnabledChange(e)}
                      />
                    </Form.Group>
                  </Form>

                  <Form>
                    <Form.Group className={`mb-3 ${Style.setting}`} controlId="formBasicEmail">
                    <Form.Label className={`${Style.textStyle}`} style={{ fontSize: '20px' }}>Multimodal</Form.Label>
                      <Form.Check
                        type="switch"
                        id="mm-switch"
                        label=""
                        checked={!!this.state.scanConfigSettings.mmEnabled}
                        onChange={(e) => this.handleOnmmEnabledChange(e)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control as="select"name="lookupCode"onChange={(e) => this.handlelookupCodeChange(e)} value={this.state.scanConfigSettings.lookupCode} disabled={true}>
                            {
                                this.props.lookupData.map((model) => (
                                  model.lookupId === "LKP_SRVC_TYPE" &&
                                    <option key={model.code} value={model.code}>{model.value}</option>
                                ))
                            }
                            </Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className={`${Style.textStyle}`} style={{ fontSize: '20px' }}>Multimodal Scan Policy</Form.Label>
                        <Form.Control as="select" name="strMMPolicy" onChange={(e) => this.handleMMScanPolicyCodeChange(e)} value={this.state.scanConfigSettings.strMMPolicy} disabled={!this.state.scanConfigSettings.mmEnabled}>
                            {
                                this.props.lookupData.map((policy) => (
                                  policy.lookupId === "LKP_MM_SCANPOLICY" &&
                                    <option key={policy.code} value={policy.code}>{policy.value}</option>
                                ))
                            }
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className={`${Style.textStyle}`} style={{ fontSize: '20px' }}>Multimodal Image Size</Form.Label>
                        <Form.Control as="select" name="imageSize" onChange={(e) => this.handleMMImageSizeChange(e)} value={this.state.scanConfigSettings.imageSize} disabled={!this.state.scanConfigSettings.mmEnabled}>
                            {
                                this.props.lookupData.map((imageDimension) => (
                                  imageDimension.lookupId === "LKP_MM_IMG_SIZE" &&
                                    <option key={imageDimension.code} value={imageDimension.code}>{imageDimension.value}</option>
                                ))
                            }
                        </Form.Control>
                    </Form.Group>
                  </Form>
                </Card.Body>
            </Card>
            <div className={`mt-2`} style={{order: 3, flexGrow: 2}}>
                        <button onClick={this.handleOnUpdate} className={`${Style.submitButton} focus-none`} > Update Settings </button>
                        <button onClick={this.handleOnCancel} className={`${Style.cancelButton} focus-none ml-3`} > Cancel  </button>
                </div>
          </Card.Body>
          }
        </Card>
      </>  

        {this.state.showConfirmationPopup && (
          <ConfirmPopup
          details={{
            icon: '',
            type: 'info',
            title: 'Are You Sure?',
            description: "Do you want to update the settings? This will affect how the Extension will Scan the URLs",
            buttons: 'Y,C',
          }}
          onCancelClick={this.handleOnClose} 
          onYesClick= {this.updateScanConfSettings}
          />
        )}

        {
          this.props.statusCode && (
            <ConfirmPopup
            details={{
              icon: '',
              type: this.props.statusCode ==  200? 'success':'error',
              title: this.props.statusCode ==  200? `Settings Updated Successfully`:`Settings Could not be updated`,
              description: this.props.scanConfigSettingsMsg || "Error in updating settings. Contact support",
              buttons: 'O',
            }}
            onCloseClick={this.handleOnClose} 
          />
          )}
    </div>
  )
  }
}

const mapStateToProps = (state) => ({
    loading: state.entities.customers.loading,
    selectedCustomer: state.entities.customers.selected,
    settingsLoading : state.entities.customers.scanConfigSettings.loading,
    scanConfigSettings : state.entities.customers.scanConfigSettings,
    statusCode : state.entities.customers.scanConfigSettings.statusCode,
    scanConfigSettingsMsg : state.entities.customers.scanConfigSettings.userMsg,
    lookupData: state.entities.lookup.data
});

const mapDispatchToProps = (dispatch) => ({
    getScanConfigSettings: (customerId) => dispatch(getScanConfigSettings(customerId)),
    updateScanConfigSettings: (customerId, body) => dispatch(updateScanConfigSettings(customerId, body)),
    getLookupData: () => dispatch(getLookupData()),
    getScanRuleLookupData: () => dispatch(getScanRuleLookupData()),
    getMMScanPolicyLookupData: () => dispatch(getMMScanPolicyLookupData()),
    getMMImageSizeLookupData: () => dispatch(getMMImageSizeLookupData()),
    unSetStatusCode: () => dispatch(unSetStatusCode())
})  

export default connect(mapStateToProps, mapDispatchToProps)(ScanSettings);
